var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "carousel",
      style: { padding: _vm.bannerPadding, height: _vm.bannerWidth },
    },
    [
      _c(
        "el-carousel",
        _vm._l(_vm.propsData.banner, function (item, index) {
          return _c("el-carousel-item", { key: index }, [
            item.pic
              ? _c("img", { staticClass: "img", attrs: { src: item.pic } })
              : _c("img", {
                  staticClass: "img",
                  attrs: {
                    src: require("../../../../../../../assets/404_images/404.png"),
                    alt: "请上传图片",
                  },
                }),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }